<template>
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="footer__menu footer__about">
                    <a href="/" class="logo">
                        <img src="../assets/logo.png" alt="">
                    </a>
                    <p class="minInfo">Все права защищены. Traffic Shark @ 2015-2021</p>
                    <a href="/" class="privacy">Terms & Conditions</a>
                    <a href="/" class="privacy">Terms & Conditions</a>
                </div>
                <div class="footer__menu footer__routers">
                    <router-link to="/">Веб-мастерам <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.56015 8.00004C9.56015 8.2868 9.45066 8.57351 9.23214 8.79214L2.35243 15.6718C1.9148 16.1094 1.20525 16.1094 0.767791 15.6718C0.330333 15.2343 0.330333 14.5249 0.767791 14.0872L6.85534 8.00004L0.768003 1.91282C0.330545 1.47518 0.330545 0.765844 0.768003 0.328423C1.20546 -0.109425 1.91501 -0.109425 2.35264 0.328422L9.23235 7.20795C9.45091 7.42668 9.56015 7.7134 9.56015 8.00004Z" fill="#2E9ADB"/></svg></router-link>
                    <router-link to="/">Рекламодателям<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.56015 8.00004C9.56015 8.2868 9.45066 8.57351 9.23214 8.79214L2.35243 15.6718C1.9148 16.1094 1.20525 16.1094 0.767791 15.6718C0.330333 15.2343 0.330333 14.5249 0.767791 14.0872L6.85534 8.00004L0.768003 1.91282C0.330545 1.47518 0.330545 0.765844 0.768003 0.328423C1.20546 -0.109425 1.91501 -0.109425 2.35264 0.328422L9.23235 7.20795C9.45091 7.42668 9.56015 7.7134 9.56015 8.00004Z" fill="#2E9ADB"/></svg></router-link>
                </div>
                <div class="footer__menu footer__socials">
                    <a href="@mailto: mukhammdjcn@gmail.com">mukhammdjcn@gmail.com 
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0496 11.9002C9.87013 12.0124 9.66824 12.0573 9.48878 12.0573C9.30933 12.0573 9.10744 12.0124 8.92798 11.9002L0 6.44922V13.6948C0 15.2426 1.2562 16.4988 2.80401 16.4988H16.196C17.7438 16.4988 19 15.2426 19 13.6948V6.44922L10.0496 11.9002Z" fill="#2E9ADB"/>
                            <path d="M16.1961 2.50122H2.80413C1.48063 2.50122 0.359029 3.44337 0.0898438 4.69956L9.51133 10.4422L18.9104 4.69956C18.6412 3.44337 17.5196 2.50122 16.1961 2.50122Z" fill="#2E9ADB"/>
                        </svg>
                    </a>
                    <a href="https://t.me/mukhammadjcn">@mukhammdjcn
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                            <path d="M7.45502 12.0183L7.14073 16.439C7.5904 16.439 7.78515 16.2458 8.01869 16.0138L10.1269 13.999L14.4953 17.1982C15.2965 17.6447 15.8609 17.4095 16.0771 16.4611L18.9445 3.02495L18.9453 3.02416C19.1994 1.83983 18.517 1.3767 17.7364 1.66725L0.881813 8.12012C-0.268478 8.56662 -0.251062 9.20787 0.686272 9.49841L4.99531 10.8387L15.0044 4.57583C15.4754 4.26391 15.9037 4.4365 15.5514 4.74841L7.45502 12.0183Z" fill="#2E9ADB"/>
                            </g>
                            <defs>
                            <clipPath id="clip0">
                            <rect width="19" height="19" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </a>
                     <a href="https://instagram.com/mukhammadjcn">@mukhammdjcn
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                             <path d="M18.2085 9.49971C18.2085 8.32068 17.9795 7.19292 17.5219 6.11677C17.0643 5.04061 16.4458 4.11301 15.6665 3.33354C14.8872 2.55408 13.9595 1.93574 12.8833 1.47813C11.8071 1.02053 10.6794 0.791598 9.50014 0.791598C8.89804 0.791598 8.27953 0.857881 7.64473 0.989773C6.78685 0.330276 5.82202 0.000244141 4.75018 0.000244141C3.439 0.000244141 2.31953 0.46415 1.39172 1.39175C0.463906 2.31935 0 3.43861 0 4.75C0 5.82226 0.329607 6.78709 0.989529 7.64434C0.857424 8.27977 0.791566 8.89832 0.791566 9.49975C0.791566 10.6792 1.02049 11.8069 1.47814 12.8831C1.93574 13.9592 2.55429 14.8868 3.33355 15.6663C4.1128 16.4457 5.04061 17.0641 6.11677 17.5217C7.19293 17.9794 8.32065 18.2083 9.49989 18.2083C10.1018 18.2083 10.7203 18.142 11.3553 18.0101C12.213 18.6695 13.1778 18.9996 14.2499 18.9996C15.5611 18.9996 16.6805 18.5357 17.6083 17.6081C18.5362 16.6803 19 15.5608 19 14.2499C19 13.1776 18.6702 12.2132 18.0105 11.3551C18.1424 10.7208 18.2085 10.1022 18.2085 9.49971ZM14.1017 13.1923C13.8295 13.6747 13.4646 14.0606 13.0069 14.3491C12.5493 14.6376 12.044 14.8585 11.4915 15.0105C10.9389 15.1632 10.3616 15.2397 9.75975 15.2397C8.36609 15.2397 7.16607 14.9696 6.16005 14.4292C5.15385 13.8891 4.65095 13.2396 4.65095 12.4809C4.65095 12.1099 4.75598 11.8006 4.96651 11.5531C5.17678 11.3058 5.48781 11.1821 5.90037 11.1821C6.13949 11.1821 6.36212 11.2484 6.56829 11.3803C6.77425 11.5122 6.96421 11.6707 7.13726 11.8563C7.31052 12.0419 7.49783 12.2275 7.70015 12.413C7.90222 12.5985 8.17011 12.7575 8.50431 12.8894C8.83827 13.0213 9.21555 13.0871 9.63614 13.0871C10.172 13.0871 10.6051 12.9823 10.9349 12.772C11.2645 12.5613 11.4298 12.2956 11.4298 11.9737C11.4298 11.6441 11.2977 11.3967 11.0339 11.2315C10.8524 11.1165 10.3907 10.9682 9.64849 10.7864L7.84244 10.3409C7.34757 10.226 6.92284 10.0917 6.56832 9.93899C6.21359 9.78671 5.88374 9.58684 5.57879 9.3393C5.27364 9.09197 5.04277 8.78073 4.88617 8.40519C4.72937 8.03028 4.6512 7.59108 4.6512 7.08754C4.6512 6.4859 4.78914 5.95593 5.06552 5.49832C5.34166 5.04068 5.70874 4.68159 6.16638 4.42216C6.62402 4.16227 7.1167 3.96841 7.64452 3.84045C8.17209 3.71291 8.71636 3.64899 9.2773 3.64899C10.0689 3.64899 10.8193 3.74362 11.5286 3.93313C12.2377 4.12306 12.8233 4.40135 13.285 4.76804C13.7468 5.13534 13.9777 5.54556 13.9777 5.99928C13.9777 6.37029 13.8601 6.68779 13.6251 6.95158C13.3901 7.21536 13.0786 7.34725 12.6911 7.34725C12.4767 7.34725 12.2788 7.29789 12.0976 7.1989C11.9161 7.09992 11.7512 6.9806 11.6027 6.83982C11.4543 6.70014 11.2976 6.56153 11.1327 6.42571C10.9677 6.2895 10.745 6.17208 10.4648 6.07292C10.1843 5.97394 9.86683 5.92457 9.51228 5.92457C8.32479 5.92457 7.73115 6.2425 7.73115 6.87687C7.73115 7.01743 7.76211 7.14108 7.82387 7.24785C7.8858 7.35571 7.95381 7.44213 8.02788 7.50774C8.10216 7.57402 8.22584 7.63963 8.39886 7.70545C8.57212 7.77174 8.71615 7.81958 8.8318 7.84796C8.94723 7.87698 9.12874 7.91987 9.37603 7.97791L10.6625 8.2746C11.0664 8.36534 11.4272 8.46022 11.7449 8.5592C12.0623 8.65818 12.4025 8.79832 12.7655 8.97958C13.1283 9.16129 13.4293 9.36315 13.6686 9.58599C13.9077 9.80819 14.1076 10.0908 14.2685 10.433C14.4294 10.7757 14.5098 11.153 14.5098 11.5651C14.51 12.168 14.3738 12.71 14.1017 13.1923Z" fill="#2E9ADB"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name : "Footer"
}
</script>

<style lang="scss">
.footer{
    padding: 0 0 64px;
    .row{
        justify-content: space-between;
        .logo{
            width: 110px;
            height: 50px;
            display: block;
        }
    }
    &__about{
        .minInfo{
            margin: 30px 0;
        }
        .privacy{
            display: block;
            font-weight: bold;
            font-size: 14px;
            line-height: 17px;
            text-transform: uppercase;
            color: #2E9ADB;
            margin: 10px 0;
        }
    }
    &__menu{
        flex-basis: 20%;
    }
    &__routers, &__socials{
            a{
                font-weight: 500;
                font-size: 16px;
                line-height: 19px;
                color: #1C1C1C;
                margin: 16px 0;
                display: block;
                position: relative;
                svg{
                    position: absolute;
                    left: -32px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
    }
}

@media(max-width:500px){
    .footer{
        .row{
            flex-direction: column;
            gap: 36px;
            align-items: flex-start;
            margin-left: 42px;
        }
        &__about{
            margin-left: -36px;
        }
    }
}
</style>